import React, { useEffect, useState } from 'react';
import { Card, Button, Form, Input, Space, message } from 'antd';
import { PlusOutlined, DeleteOutlined, SaveOutlined } from '@ant-design/icons';

interface ProductLink {
  title: string;
  href: string;
  sort_order: number;
}

interface FooterProductsEditorProps {
  data: ProductLink[];
  onSave: (data: ProductLink[]) => void;
}

const FooterProductsEditor: React.FC<FooterProductsEditorProps> = ({ data, onSave }) => {
  const [products, setProducts] = useState<ProductLink[]>(
    data && data.length > 0
      ? data
      : [
          { title: '精准给药计算', href: '/#features', sort_order: 1 },
          { title: 'TDM 剂量优化', href: '/#features', sort_order: 2 },
          { title: 'AI 智能助手', href: '/#features', sort_order: 3 },
          { title: 'PK 曲线分析', href: '/#features', sort_order: 4 },
        ]
  );

  useEffect(() => {
    if (Array.isArray(data)) {
      setProducts([...data].sort((a, b) => (a.sort_order || 0) - (b.sort_order || 0)));
      return;
    }
    setProducts([
      { title: '精准给药计算', href: '/#features', sort_order: 1 },
      { title: 'TDM 剂量优化', href: '/#features', sort_order: 2 },
      { title: 'AI 智能助手', href: '/#features', sort_order: 3 },
      { title: 'PK 曲线分析', href: '/#features', sort_order: 4 },
    ]);
  }, [data]);

  const handleAdd = () => {
    const newProduct: ProductLink = {
      title: '新产品',
      href: '/#',
      sort_order: products.length + 1,
    };
    setProducts([...products, newProduct]);
  };

  const handleRemove = (index: number) => {
    const newProducts = products.filter((_, i) => i !== index);
    // Re-sort
    newProducts.forEach((product, i) => {
      product.sort_order = i + 1;
    });
    setProducts(newProducts);
  };

  const handleChange = (index: number, field: keyof ProductLink, value: string | number) => {
    const newProducts = [...products];
    newProducts[index] = { ...newProducts[index], [field]: value };
    setProducts(newProducts);
  };

  const handleSave = () => {
    // Validate
    for (const product of products) {
      if (!product.title || !product.href) {
        message.error('请填写所有产品的标题和链接');
        return;
      }
    }
    onSave(products);
  };

  return (
    <Card
      title="Footer 产品列表配置"
      extra={
        <Space>
          <Button icon={<PlusOutlined />} onClick={handleAdd}>
            添加产品
          </Button>
          <Button type="primary" icon={<SaveOutlined />} onClick={handleSave}>
            保存配置
          </Button>
        </Space>
      }
    >
      <Space direction="vertical" size="middle" style={{ width: '100%' }}>
        {products.map((product, index) => (
          <Card key={index} size="small" type="inner">
            <Space direction="vertical" size="small" style={{ width: '100%' }}>
              <Form layout="inline">
                <Form.Item label="排序">
                  <Input
                    type="number"
                    value={product.sort_order}
                    onChange={(e) => handleChange(index, 'sort_order', parseInt(e.target.value) || 0)}
                    style={{ width: 80 }}
                  />
                </Form.Item>
                <Form.Item label="标题">
                  <Input
                    value={product.title}
                    onChange={(e) => handleChange(index, 'title', e.target.value)}
                    placeholder="精准给药计算"
                    style={{ width: 180 }}
                  />
                </Form.Item>
                <Form.Item label="链接">
                  <Input
                    value={product.href}
                    onChange={(e) => handleChange(index, 'href', e.target.value)}
                    placeholder="/#features"
                    style={{ width: 220 }}
                  />
                </Form.Item>
                <Form.Item>
                  <Button
                    danger
                    icon={<DeleteOutlined />}
                    onClick={() => handleRemove(index)}
                  >
                    删除
                  </Button>
                </Form.Item>
              </Form>
            </Space>
          </Card>
        ))}
      </Space>
    </Card>
  );
};

export default FooterProductsEditor;
